import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Notification, NotificationViewResponse } from '../interfaces/notifications.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    getNotifications(): Observable<Notification[]> {
        const url = this.urlsService.NOTIFICATIONS.NOTIFICATION_COLLECTION;
        return this.ajaxService.getDataObserveBody<Notification[]>(url);
    }

    deleteNotifications(): Observable<HttpResponse<{}>> {
        const url = this.urlsService.NOTIFICATIONS.NOTIFICATION_COLLECTION;
        return this.ajaxService.deleteDataObserveResponse<{}>(url);
    }

    markNotificationAsRead(notification: Notification): Observable<HttpResponse<NotificationViewResponse>> {
        const url = this.urlsService.getUrl(this.urlsService.NOTIFICATIONS.NOTIFICATION_VIEW, {
            notificationType: notification.type,
            notificationId: notification.id,
        });
        return this.ajaxService.putDataObserveResponse<NotificationViewResponse>(url, {});
    }

    deleteNotification(notification: Notification): Observable<HttpResponse<NotificationViewResponse>> {
        const url = this.urlsService.getUrl(this.urlsService.NOTIFICATIONS.NOTIFICATION_VIEW, {
            notificationType: notification.type,
            notificationId: notification.id,
        });
        return this.ajaxService.deleteDataObserveResponse<NotificationViewResponse>(url);
    }
}
